var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrend = function SvgTrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 60 60",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.564 46.77c1.027 1.581 1.085 3.181 0.175 4.803-0.907 1.618-2.308 2.427-4.205 2.427h-49.067c-1.896 0-3.299-0.809-4.209-2.427-0.908-1.622-0.847-3.222 0.18-4.803l24.533-38.637c0.948-1.422 2.291-2.133 4.03-2.133 1.738 0 3.081 0.711 4.029 2.133l24.534 38.637z",
    fillRule: "nonzero"
  })));
};
export default SvgTrend;